import {FC} from 'react';
import {Typography} from '@mui/material';
import {FormattedMessage} from 'react-intl';
import {missingBexioPillSx} from './MissingBexioPill.sx';

/**
 * "No Bexio integration", said out loud.
 *
 * On a desktop row the warning is a red name and a tooltip. Neither survives a phone: there is no
 * hover to open the tooltip, and a red name only reads as a warning to somebody who has the black
 * ones beside it to compare against. A card says it in words, in the row of pills where the card
 * already keeps everything else that is true about the record.
 *
 * Render it behind [[useMissingBexio]] - the hook decides, this only shows.
 */
export const MissingBexioPill: FC = () => (
    <Typography
        component="span"
        sx={missingBexioPillSx}
    >
        <FormattedMessage id="noBexioIntegration"/>
    </Typography>
);
